module.exports = __webpack_public_path__ + "img/inxbtn.5cd8ed91.png";